<template>
  <div class="volume">
    <button class="volume__icon" v-on:click="toggleVolume" :title="$t(muteButtonState)">
      <icon :name="volumeIcon" scale="1.25"></icon>
    </button>

    <label class="volume__slider">
      <span class="u-sr-only">{{ $t('volume_control') }}</span>
      <vue-slider ref="vueSlider" :value="volume"
                  v-bind="sliderProps" :processStyle="{ backgroundColor: `rgb(${this.themeColor.join(',')})` }"
                  v-on:drag-start="dragStart"
                  v-on:drag-end="dragEnd"
                  v-on:callback="updateVolume"></vue-slider>
    </label>

    <div class="volume__value u-dimmed">
      {{ volumePourcent }}
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      volume: {
        type: Number,
        default: 0.5
      },
      themeColor: {
        type: Array,
        default: [0, 0, 0]
      },
      isMenuOpen: {
        type: Boolean,
        default: false
      }
    },

    data () {
      return {
        sliderInUse: false,
        sliderProps: {
          tooltip: false,
          bgStyle: { backgroundColor: 'rgba(255,255,255, 0.25)' },
          height: 3,
          dotSize: 25,
          max: 1,
          interval: 0.01
        },
        oldVolume: this.volume,
        muteButtonState: 'mute'
      }
    },

    watch: {
      isMenuOpen () {
        this.$refs.vueSlider.refresh()
      }
    },

    computed: {
      volumePourcent () {
        return `${Math.ceil(this.volume * 100)}%`
      },

      volumeIcon () {
        if (this.volume <= 0) return 'volume-lvl-0'
        if (this.volume <= 0.35) return 'volume-lvl-1'
        if (this.volume <= 0.65) return 'volume-lvl-2'
        return 'volume-lvl-3'
      }
    },

    methods: {
      dragStart (context) {
        this.sliderInUse = true
      },

      dragEnd (context) {
        this.sliderInUse = false
        this.updateVolume(context.getValue())
      },

      updateVolume (slideValue) {
        if (this.sliderInUse) return

        this.$emit('volumeupdate', slideValue)
      },

      toggleVolume () {
        if (this.volume !== 0) {
          this.oldVolume = this.volume
          this.updateVolume(0)
          this.muteButtonState = 'unmute'
        } else {
          this.updateVolume(
            this.audible(this.oldVolume)
          )
          this.muteButtonState = 'mute'
        }
      },

      audible (volume) {
        if (volume > 0) return volume
        return 0.5
      }
    }
  }
</script>

<style>
  .volume {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .volume__slider, .volume__value {
    display: none;
  }

  .volume__slider {
    flex-grow: 1;
  }

  .volume__icon svg {
    display: block;
  }

  .volume__value {
    width: 2.75em;
    font-size: 0.87em;
  }

  @media screen and (min-width: 600px) {
    .volume__slider, .volume__value {
      display: block;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Volume.vue